<template>
  <MyOrdersTab v-bind="{ fetchActive, fetchPast }" type="scratchcard">
    <template #no-results>
      <MyOrdersNoResults variant="scratchcard" />
    </template>

    <template #active="{ result }">
      <li
        v-for="order in getScratchcards(result)"
        :key="order.orderId"
        data-containerid="scratchcards_list_active"
      >
        <MyOrdersScratchcardCardActive :data="order" />
      </li>
    </template>

    <template #past="{ result }">
      <li
        v-for="order in getScratchcards(result)"
        :key="order.orderId"
        data-containerid="scratchcards_list_past"
      >
        <MyOrdersScratchcardCardPast :data="order" />
      </li>
    </template>
  </MyOrdersTab>
</template>

<script lang="ts" setup>
import {
  type ScratchcardOrdersQuery,
  ScratchcardState,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

const ACTIVE_STATUS = [ScratchcardState.Purchased, ScratchcardState.Scratched]
const PAST_STATUS = [ScratchcardState.Revealed, ScratchcardState.Cancelled]

const fetchActive = () =>
  useScratchcardOrders({
    limit: 20,
    status: ACTIVE_STATUS,
  })

const fetchPast = () =>
  useScratchcardOrders({
    limit: 3,
    status: PAST_STATUS,
  })

const getScratchcards = (result: ScratchcardOrdersQuery) =>
  result.scratchcardOrders.scratchcardOrders
</script>
